import { render, staticRenderFns } from "./zhudaochanyelian.vue?vue&type=template&id=4a1d7bdd&scoped=true&"
import script from "./zhudaochanyelian.vue?vue&type=script&lang=js&"
export * from "./zhudaochanyelian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1d7bdd",
  null
  
)

export default component.exports